module.exports = __webpack_public_path__ + "img/popust.25ede0be.png";